import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

export const ReactAutoCompleteStyles = (theme: Theme) => createStyles({

    popperRoot: {
        zIndex: theme.zIndex.drawer + 1,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.palette.grey[700],
        maxHeight: 300,
        overflowY: "auto"
    },

    popperRootOverModal : {
        zIndex: theme.zIndex.modal + 1,
    },

    popList: {
        paddingTop: 4,
        paddingBottom: 4,
        fontSize: ".85rem",
        lineHeight: "auto",
        height: "auto",
        minHeight: "unset"
    },

    autocompleteInputRoot: {
        flexWrap: "wrap",
        "& input": {
            width: "1px",
            flexGrow: 1
        }
    },
    autocompleteChip: {
        margin: parseInt(theme.spacing()) / 2,
        "& img": {
            "object-fit": "scale-down"
        }
    },

    autocompleteLimitedWidth: {
        maxWidth: "200px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});